// extracted by mini-css-extract-plugin
export default {"wrapper":"s0-z","play":"t0-z"};